module.exports = __webpack_public_path__ + "img/x9.8766728d.jpg";